module.exports = __webpack_public_path__ + "img/icon-variety-games.cab27c7c.png";